import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { FullScreenIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const FullScreenIconButton = forwardRef<
  HTMLButtonElement,
  ExtendedIconButtonProps
>(({ tooltipTitle, ...props }, ref) => {
  const { t } = useTranslation();
  const resolvedTooltipTitle =
    tooltipTitle ?? t('common.full_screen', 'Full screen');

  return (
    <IconButton ref={ref} {...props} tooltipTitle={resolvedTooltipTitle}>
      <FullScreenIcon color="inherit" />
    </IconButton>
  );
});

FullScreenIconButton.displayName = 'FullScreenIconButton';
export default FullScreenIconButton;
